import { render } from "./Signup.vue?vue&type=template&id=2d20b1a4&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=2d20b1a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d20b1a4"

export default script